'use client';

import { CacheKey } from '@eliadmin/core/src/api/constants';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useProformAddToCart } from '@eliadmin/core/src/hooks/proform-add-to-cart';
import { useProformValidation } from '@eliadmin/core/src/hooks/proform-validation';
import { useCartPresence } from '@eliadmin/core/src/hooks/use-cart-presence';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import {
  useConfiguratorStore,
  useSetValueMutationPending,
} from '@eliadmin/core/src/stores/configurator-store';
import { useQueryClient } from '@tanstack/react-query';
import { RiShoppingCartFill } from 'react-icons/ri';

export function ConfiguratorAddToCartMobile() {
  const mutation = useProformAddToCart();
  const cartPresence = useCartPresence();
  const isValid = useProformValidation();
  const isSetMutationPending = useSetValueMutationPending();
  const { t } = useTranslations();
  const queryClient = useQueryClient();
  const conf = useConfiguratorStore(s => s.productConf);

  return (
    <Button
      onClick={() => {
        if (!isValid) return;
        mutation.mutate(conf).then(() => {
          // timeout to make sure cart has been updated when we refetch cart
          setTimeout(() => queryClient.invalidateQueries({ queryKey: [CacheKey.CART] }), 1000);
        });
      }}
      isLoading={mutation.isPending}
      disabled={!isValid || isSetMutationPending}
      className="col-span-2 flex items-center justify-center gap-2.5 rounded-full border border-[#09BD05] bg-[#09BD05] py-7 text-base text-white shadow-none hover:bg-[#08bd05c0]"
    >
      <RiShoppingCartFill size={20} />
      {!cartPresence ? t('text227') : t('text1198')}
    </Button>
  );
}
